module.exports = __webpack_public_path__ + "media/images/themes/mandy/15-a0f3ac7de733193094c5b1e64bcc5a90.png";